const FAVICON_HREF = "/favicon.png"
const BADGE_COLOR = "#e5323a"
const POLL_INTERVAL = 60000

let badgeHref = null

function buildBadgeFavicon() {
  if (badgeHref) return Promise.resolve(badgeHref)

  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => {
      const canvas = document.createElement("canvas")
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext("2d")
      ctx.drawImage(img, 0, 0)

      const radius = img.width * 0.3
      const cx = img.width - radius
      const cy = radius

      ctx.beginPath()
      ctx.arc(cx, cy, radius, 0, 2 * Math.PI)
      ctx.fillStyle = "#fff"
      ctx.fill()

      ctx.beginPath()
      ctx.arc(cx, cy, radius * 0.7, 0, 2 * Math.PI)
      ctx.fillStyle = BADGE_COLOR
      ctx.fill()

      badgeHref = canvas.toDataURL("image/png")
      resolve(badgeHref)
    }
    img.onerror = () => resolve(null)
    img.src = FAVICON_HREF
  })
}

function setFavicon(href) {
  const link = document.querySelector('link[rel="icon"]')
  if (link) link.href = href
}

function applyUnreadState(unread) {
  if (unread) {
    buildBadgeFavicon().then((href) => href && setFavicon(href))
  } else {
    setFavicon(FAVICON_HREF)
  }
}

export function initFaviconNotifications() {
  const { body } = document
  if (!body.dataset.latestBlackboardId) return

  let sinceId = Number.parseInt(body.dataset.latestBlackboardId, 10) || 0
  let unread = body.dataset.hasUnread === "true"

  applyUnreadState(unread)

  const poll = () => {
    fetch(`/notifications/status/?since=${sinceId}`, {
      credentials: "same-origin",
    })
      .then((r) => r.json())
      .then((data) => {
        sinceId = data.latestBlackboardId
        if (data.unread !== unread) {
          unread = data.unread
          applyUnreadState(unread)
        }
      })
      .catch(() => {})
  }

  setInterval(poll, POLL_INTERVAL)
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") poll()
  })
}
